import {
	FlexAlign,
	FlexGap,
	FlexJustify,
	StackHorizontal,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React from 'react';

function ChangePassword() {
	const { t } = useTranslation();

	return (
		<StackVertical gap={FlexGap.Small}>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-xs'>
				<h2 className='mb-0'>{t('settings.changePassword.title')}</h2>
			</StackHorizontal>
		</StackVertical>
	);
}

export { ChangePassword };
